const FIVE_VERTICAL_THUMBNAILS =
  'slideshow-controls[thumbnails][data-item-count="5"]:is([pagination-position="left"], [pagination-position="right"])';
const DESKTOP_QUERY = '(min-width: 750px)';
const desktopQuery = window.matchMedia(DESKTOP_QUERY);
const observedSlideshows = new WeakSet();

function directChild(element, selector) {
  for (const child of element.children) {
    if (child.matches(selector)) return child;
  }
}

function readPixels(element, property) {
  const value = window.getComputedStyle(element).getPropertyValue(property);
  const parsed = Number.parseFloat(value);

  return Number.isFinite(parsed) ? parsed : 0;
}

function syncThumbnailSize(slideshow) {
  const controls = directChild(slideshow, FIVE_VERTICAL_THUMBNAILS);
  const container = directChild(slideshow, 'slideshow-container');

  if (!controls || !container || !desktopQuery.matches) {
    slideshow.style.removeProperty('--fitted-thumbnail-size');
    slideshow.style.removeProperty('--fitted-thumbnail-rail-height');
    slideshow.style.removeProperty('--fitted-thumbnail-gap');
    slideshow.style.removeProperty('--fitted-thumbnail-padding-block');
    return;
  }

  const selectedMedia =
    container.querySelector('slideshow-slide[aria-hidden="false"].product-media-container') ||
    container.querySelector('slideshow-slide[aria-hidden="false"] .product-media-container');
  const renderedMedia = selectedMedia?.querySelector('.product-media__image, .deferred-media__poster-image, video, iframe, model-viewer');
  const targetHeight =
    renderedMedia?.getBoundingClientRect().height ||
    selectedMedia?.getBoundingClientRect().height ||
    container.getBoundingClientRect().height;
  if (!targetHeight) return;

  const thumbnails = controls.querySelector('.slideshow-controls__thumbnails');
  const itemCount = Number.parseInt(controls.dataset.itemCount, 10) || 5;
  const measuredGap = thumbnails ? readPixels(thumbnails, 'gap') : 0;
  const paddingBlock = thumbnails ? readPixels(thumbnails, 'padding-top') + readPixels(thumbnails, 'padding-bottom') : 0;
  const fittedThumbnailGap = Math.max(0, Math.min(measuredGap, targetHeight * 0.012));
  const fittedThumbnailPaddingBlock = Math.max(0, Math.min(paddingBlock, targetHeight * 0.04));
  const availableHeight = Math.max(0, targetHeight - fittedThumbnailGap * (itemCount - 1) - fittedThumbnailPaddingBlock);
  const fittedThumbnailSize = availableHeight / itemCount;

  slideshow.style.setProperty('--fitted-thumbnail-rail-height', `${targetHeight}px`);
  slideshow.style.setProperty('--fitted-thumbnail-size', `${fittedThumbnailSize}px`);
  slideshow.style.setProperty('--fitted-thumbnail-gap', `${fittedThumbnailGap}px`);
  slideshow.style.setProperty('--fitted-thumbnail-padding-block', `${fittedThumbnailPaddingBlock / 2}px`);
}

function observeSlideshow(slideshow) {
  if (observedSlideshows.has(slideshow)) return;

  observedSlideshows.add(slideshow);

  const container = directChild(slideshow, 'slideshow-container');
  const observer = new ResizeObserver(() => syncThumbnailSize(slideshow));

  observer.observe(slideshow);
  if (container) observer.observe(container);
  slideshow.querySelectorAll('img').forEach((image) => image.addEventListener('load', () => syncThumbnailSize(slideshow)));

  syncThumbnailSize(slideshow);
}

function syncAllGalleries() {
  document.querySelectorAll('media-gallery.media-gallery--carousel > slideshow-component').forEach(observeSlideshow);
}

syncAllGalleries();
document.addEventListener('shopify:section:load', syncAllGalleries);
desktopQuery.addEventListener('change', syncAllGalleries);
